import React, { useState, useEffect } from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { getServices } from '../services/api';

const Services = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await getServices();
        setServices(data);
      } catch (error) {
        console.error('Error loading services:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  const categories = ['Tous', ...new Set(services.map(s => s.category))];

  const filteredServices = selectedCategory === 'Tous' 
    ? services 
    : services.filter(s => s.category === selectedCategory);

  if (loading) {
    return (
      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
        <p className="body-large">Chargement des services...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <section 
        style={{
          position: 'relative',
          height: '50vh',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          background: 'var(--bg-secondary)'
        }}
      >
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url(https://images.pexels.com/photos/5659010/pexels-photo-5659010.jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.5)'
          }}
        />
        
        <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-large" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
            Nos Services
          </h1>
          <p className="body-large" style={{ color: 'var(--bg-primary)' }}>
            Des prestations sur mesure pour révéler votre beauté
          </p>
        </div>
      </section>

      {/* Filtres de catégorie */}
      <section style={{ background: 'var(--bg-primary)', padding: '40px 0' }}>
        <div className="container">
          <div style={{ 
            display: 'flex', 
            gap: '16px', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            borderBottom: '1px solid var(--border-light)',
            paddingBottom: '16px'
          }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className="navigation-text"
                style={{
                  padding: '12px 24px',
                  background: selectedCategory === category ? 'var(--interactive-base)' : 'transparent',
                  color: selectedCategory === category ? 'var(--bg-primary)' : 'var(--text-primary)',
                  border: '1px solid var(--border-medium)',
                  borderRadius: '0px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  fontSize: '14px',
                  fontWeight: selectedCategory === category ? 700 : 400
                }}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Liste des services */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="grid-product-showcase">
            {filteredServices.map((service) => (
              <div key={service.id} className="product-card">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="product-card-image"
                  style={{ width: '100%', height: '280px', objectFit: 'cover' }}
                />
                <div style={{ padding: '24px' }}>
                  <p className="body-small" style={{ color: '#C9A961', marginBottom: '8px', fontWeight: 700 }}>
                    {service.category}
                  </p>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                    {service.title}
                  </h3>
                  <p className="product-card-description" style={{ marginBottom: '20px' }}>
                    {service.description}
                  </p>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    borderTop: '1px solid var(--border-light)',
                    paddingTop: '16px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Clock size={16} color="var(--text-secondary)" />
                      <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        {service.duration}
                      </span>
                    </div>
                    <span className="heading-2" style={{ color: '#C9A961' }}>
                      {service.price}€
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Réservation */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            Prête pour une transformation ?
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Réservez votre rendez-vous en ligne et profitez de nos prestations d'exception
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a 
              href="https://www.planity.com/nina-care-institut-91360-villemoisson-sur-orge" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Réserver maintenant
              <ArrowRight size={16} style={{ marginLeft: '8px' }} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
